import { useState } from 'react';
import PropTypes from 'prop-types';
import {
    Facebook,
    Twitter,
    Linkedin,
    Link as LinkIcon,
    Check,
    Share2
} from 'lucide-react';

const ShareComponent = ({ url = "https://example.com", title = "Check this out!" }) => {
    const [copied, setCopied] = useState(false);

    const shareLinks = {
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
        twitter: `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)}`,
        linkedin: `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(url)}&title=${encodeURIComponent(title)}`,
        whatsapp: `https://api.whatsapp.com/send?text=${encodeURIComponent(title)} ${encodeURIComponent(url)}`
    };

    const copyToClipboard = async () => {
        try {
            await navigator.clipboard.writeText(url);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            console.error('Failed to copy:', err);
        }
    };

    return (
        <div className="flex flex-col items-start gap-4 my-8">
            <h3 className="text-lg font-semibold text-gray-700">Share this article</h3>
            <div className="flex gap-4">
                <a
                    href={shareLinks.whatsapp}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-2 rounded-full bg-green-500 text-white hover:bg-green-600 transition-colors"
                    aria-label="Share on WhatsApp"
                >
                    <Share2 size={20} />
                </a>
                <a
                    href={shareLinks.facebook}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-2 rounded-full bg-blue-600 text-white hover:bg-blue-700 transition-colors"
                    aria-label="Share on Facebook"
                >
                    <Facebook size={20} />
                </a>
                <a
                    href={shareLinks.twitter}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-2 rounded-full bg-sky-500 text-white hover:bg-sky-600 transition-colors"
                    aria-label="Share on Twitter"
                >
                    <Twitter size={20} />
                </a>
                <a
                    href={shareLinks.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-2 rounded-full bg-blue-700 text-white hover:bg-blue-800 transition-colors"
                    aria-label="Share on LinkedIn"
                >
                    <Linkedin size={20} />
                </a>
                <button
                    onClick={copyToClipboard}
                    className="p-2 rounded-full bg-gray-600 text-white hover:bg-gray-700 transition-colors"
                    aria-label="Copy link"
                >
                    {copied ? <Check size={20} /> : <LinkIcon size={20} />}
                </button>
            </div>
            {copied && (
                <span className="text-sm text-green-600 font-medium">
                    Link copied to clipboard!
                </span>
            )}
        </div>
    );
};

ShareComponent.propTypes = {
    url: PropTypes.string,
    title: PropTypes.string
};

export default ShareComponent;